// 域名配置系统

// 默认配置(当前网站使用的配置)
const defaultConfig = {
  logo: require('@/static/img/mobile_logo.jpg'),
  primaryColor: '#409EFF',
  headerBg: '#fff',
  textColor: '#333',
  // API请求全局变量
  apiParams: {
    client: 'web',
    source: 2,
    countryCode: 'BR'
  }
}

// 特殊域名配置
const domainConfigs = {
  'example.com': {
    logo: require('@/static/img/mobile_logo.jpg'),
    primaryColor: '#67C23A',
    headerBg: '#f5f5f5',
    textColor: '#666',
    apiParams: {
      client: 'web',
      source: 3,
      countryCode: 'US'
    }
  }
  // 添加更多域名配置
}

// 获取当前域名配置
export function getDomainConfig() {
  const hostname = window.location.hostname

  // 查找匹配的域名配置
  for (const domain in domainConfigs) {
    if (hostname.includes(domain)) {
      return domainConfigs[domain]
    }
  }

  // 返回默认配置
  return defaultConfig
}

// 应用主题色
export function applyTheme(config) {
  document.documentElement.style.setProperty('--primary-color', config.primaryColor)
  document.documentElement.style.setProperty('--header-bg', config.headerBg)
  document.documentElement.style.setProperty('--text-color', config.textColor)
}
